<!-- src/components/DevEnvAlert.vue -->
<template>
  <div
    v-if="isDev"
    ref="alert"
    class="dev-alert"
style="position: sticky; top: 0; z-index: 9999; width: 100%;"
  >
    <q-banner
      class="text-center q-pa-sm"
      dense
      rounded="none"
      style="border-radius: 0; background-color: #FFE3E2; color: #C41C30"
      
    >
      Ambiente de desarrollo no productivo
    </q-banner>
  </div>
</template>

<script>
export default {
    name:'DevAlert',
    setup(){
        const isDev = process.env.VUE_APP_ENVIRONMENT !== "production";

        return {
            isDev
        }
    }
}
</script>
